import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 * Fires when the app successfully loads the bootstrap API after it makes a "bootstrapRequest".
 * This happens during the app launch process.
 */
export const bootstrapLoadedBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.LAUNCH,
  eventName: EVENT_NAMES.BOOTSTRAP_LOADED,
});
